import React from 'react';
import * as msgpub from "msgpub";
import {TextArea, ButtonG, Heading, toStringArray} from '../Common';
import { Grid, Box, ResponsiveContext, Select, TextInput } from 'grommet';
import TopicComponent from './TopicComponent'
import { HeaderStyleForGrommet, MainStyleForGrommet } from '../../constant/Styles';
import { anyCallBackFunction, searchText } from '../../common/AdminMqtt';
import { DisabelesAdminContext } from '../../constant/AdminMqtt';
import { status_mapper } from '../../common/common';

const AREAS: {[key: string]: any[]} = {
    small: [
        { name: "area1", start: [0, 0], end: [0, 0] },
        { name: "area2", start: [0, 1], end: [0, 1] },
    ],
    medium: [
        { name: 'area1', start: [0, 0], end: [1, 0] },
        { name: 'area2', start: [1, 0], end: [2, 0] },
    ],
    large: [
        { name: 'area1', start: [0, 0], end: [1, 0] },
        { name: 'area2', start: [1, 0], end: [2, 0] },
    ]
};

const ROWS: {[key: string]: any[]} = {
    small: ['auto', 'auto'],
    medium: ['auto'],
    large: ['auto']
};

const COLUMNS: {[key: string]: any[]} = {
    small: ['auto'],
    medium: ['auto', 'auto'],
    large: ['auto', 'auto'],
}

interface PubSubProps {
    admin?: msgpub.Admin;
    setLog: any;
    callbackAdd: any;
    callbackRemove: any;
    logMsg: string;
    pubsubListStr: string;
    setPubSubListStr: any;
    pubsubTextAreaId: string;
    pubsubTextAreaPlaceHolder: string;
    callbackForPubSubList: any;
    buttonNameForPubSubList: string;
}

const AdminPubSubComponent = (props: {pubSubProps: PubSubProps}) => {
    const {pubSubProps} = props;
    const {admin, setLog, callbackAdd, callbackRemove, logMsg, pubsubListStr, setPubSubListStr, pubsubTextAreaId, pubsubTextAreaPlaceHolder, callbackForPubSubList, buttonNameForPubSubList} = pubSubProps;
    const [topicList, setTopicList] = React.useState<Array<string>>([]);
    const [searchedTopicList, setSearchedTopicList] = React.useState<Array<string>>([]);
    const [userList, setUserList] = React.useState<Array<string>>([]);
    const [searchedUserList, setSearchedUserList] = React.useState<Array<string>>([]);
    const [valueForTopic, setValueForTopic] = React.useState("");
    const [valueForUser, setValueForUser] = React.useState("");
    const disables = React.useContext(DisabelesAdminContext);

    const add = () => {
        const userApp = valueForUser.split("@");
        callbackAdd({
            topic: valueForTopic,
            au: userApp.length === 1 ? { user: valueForUser } : { user: userApp[0], app: userApp[1] },
            callback: (status: msgpub.Status) => {
                setLog((prevLog: string) => (prevLog + "[add" + logMsg + " operation]status: " + status_mapper(status) + "\n"));
            }
        });
    };

    const remove = () => {
        const userApp = valueForUser.split("@");
        callbackRemove({
            topic: valueForTopic,
            au: userApp.length === 1 ? { user: valueForUser } : { user: userApp[0], app: userApp[1] },
            callback: (status: msgpub.Status) => {
                setLog((prevLog: string) => (prevLog + "[remove" + logMsg + " operation]status: " + status_mapper(status) + "\n"));
            }
        });
    };

    const getTopicsCurried = () => {
        anyCallBackFunction(setTopicList, setSearchedTopicList, setLog, admin?.setTopicInfoCallback.bind(admin), admin?.getTopics.bind(admin), "getTopics");
    }

    const getUsersCurried = () => {
        anyCallBackFunction(setUserList, setSearchedUserList, setLog, admin?.setUserInfoCallback.bind(admin), admin?.getUsers.bind(admin), "getUsers");
    }

    return (
        <div>
            <Box {...HeaderStyleForGrommet}>
                <Heading title={logMsg + " permission control"}/>
            </Box>
            <Box {...MainStyleForGrommet}>
                <form>
                    <Select
                        placeholder="select topic"
                        value={valueForTopic}
                        onSearch={input => {searchText(input, topicList, setSearchedTopicList)}}
                        onChange={(event) => {
                            setValueForTopic(event.value);
                        }}
                        onOpen={getTopicsCurried}
                        options={searchedTopicList}
                        disabled={disables.others}
                    />
                    <Select
                        placeholder="select user"
                        value={valueForUser}
                        onSearch={input => {searchText(input, userList, setSearchedUserList)}}
                        onChange={(event) => {
                            setValueForUser(event.target.value);
                        }}
                        onOpen={getUsersCurried}
                        options={searchedUserList}
                        disabled={disables.others}
                    />
                    <ButtonG name="add" callback={add} disabled={disables.others} />
                    <ButtonG name="delete" callback={remove} disabled={disables.others} />
                </form>
            </Box>
            <TextArea texts={pubsubListStr} name={pubsubTextAreaPlaceHolder} disabled={disables.others} id={pubsubTextAreaId} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setPubSubListStr(e.target.value)}}/>
            <ButtonG name={buttonNameForPubSubList} callback={callbackForPubSubList} disabled={disables.others} />
        </div>
    );
}


export default function TopicPubSubComponent(props: {admin?: msgpub.Admin}) {
    const {admin} = props;
    const [log, setLog] = React.useState("");
    const [pubList, setPubList] = React.useState<string>("");
    const [subList, setSubList] = React.useState<string>("");
    const size = React.useContext(ResponsiveContext); // Requires a Grommet Component.
    const areas = AREAS[size];
    const rows = ROWS[size];
    const columns = COLUMNS[size];
    const disables = React.useContext(DisabelesAdminContext);

    const getTopicsWrapper = (setHandler: any) => {
        admin?.setTopicInfoCallback((topics: string[]) => {
            setHandler(topics);
        });

        admin?.getTopics({
            callback: (status) => {
                setLog(log => (log + "[getTopics func]status: " + status_mapper(status) + "\n"));
            }
        });
    }

    const getPubList = () => {
        admin?.setPubInfoCallback((publist: msgpub.TopicAppUser[]) => {
            setPubList(toStringArray(publist).join('\n'));
        });

        admin?.getPubList();
    }

    const getSubList = () => {
        admin?.setSubInfoCallback((sublist: msgpub.TopicAppUser[]) => {
            setSubList(toStringArray(sublist).join('\n'));
        });

        admin?.getSubList();
    }

    const pubProps: PubSubProps = {
        admin: admin,
        setLog: setLog,
        callbackAdd: admin === undefined ? undefined : admin.addPub.bind(admin),
        callbackRemove: admin === undefined ? undefined : admin.removePub.bind(admin),
        logMsg: "pub",
        pubsubListStr: pubList,
        setPubSubListStr: setPubList,
        pubsubTextAreaId: "pub-list",
        pubsubTextAreaPlaceHolder: "pub permissions",
        callbackForPubSubList: getPubList,
        buttonNameForPubSubList: "get pub permissions"
    }

    const subProps: PubSubProps = {
        admin: admin,
        setLog: setLog,
        callbackAdd: admin === undefined ? undefined : admin.addSub.bind(admin),
        callbackRemove: admin === undefined ? undefined : admin.removeSub.bind(admin),
        logMsg: "sub",
        pubsubListStr: subList,
        setPubSubListStr: setSubList,
        pubsubTextAreaPlaceHolder: "sub permissions",
        pubsubTextAreaId: "sub-list",
        callbackForPubSubList: getSubList,
        buttonNameForPubSubList: "get sub permissions"
    }

    return (
        <div>
            <Grid
                rows={rows}
                columns={columns}
                gap="small"
                areas={areas}
            >
                <Box>
                    <TopicComponent admin={admin} getTopics={getTopicsWrapper} setLog={setLog}/>
                </Box>
                <Box>
                    <AdminPubSubComponent pubSubProps={pubProps}/>
                </Box>
                <Box>
                    <AdminPubSubComponent pubSubProps={subProps}/>
                </Box>
            </Grid>
            <TextArea texts={log} name={"log"} disabled={disables.others} id={"topic-pub-sub-log"} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setLog(e.target.value)}}/>
        </div>
    );
}
